import { Box, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface ItemProps {
  label: string
  minutes: number
}

const Item = ({ label, minutes }: ItemProps) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Text size="200">{label}</Text>
      <Box>
        <MinutesToText value={minutes} size="200" weight="medium" />
      </Box>
    </Box>
  )
}

export default Item
